import { render } from "./MenteeProfileSettingsPage.vue?vue&type=template&id=44c9f363&scoped=true"
import script from "./MenteeProfileSettingsPage.vue?vue&type=script&lang=js"
export * from "./MenteeProfileSettingsPage.vue?vue&type=script&lang=js"

import "./MenteeProfileSettingsPage.vue?vue&type=style&index=0&id=44c9f363&scoped=true&lang=css"

import exportComponent from "/root/mentoringplatform-acm/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44c9f363"]])

export default __exports__